"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFeatureBullets = void 0;
const react_1 = __importDefault(require("react"));
const canvas_box_1 = require("../canvas-box");
const view_1 = require("../html-widget/view");
const list_1 = require("../list");
const themed_text_1 = require("../themed-text");
const ProductFeatureBullets = (props) => {
    const { aboutThisItemCopy, featureBullets, listLineHeight, headingFontSize = 'basePlus', headingMargin } = props;
    return featureBullets ? (react_1.default.createElement("div", null,
        aboutThisItemCopy && (react_1.default.createElement(canvas_box_1.CanvasContainer, { margin: headingMargin },
            react_1.default.createElement(themed_text_1.ThemedHeading, { bold: true, font: headingFontSize, headingLevel: 2, "data-cy": "product-feature-bullets-header" }, aboutThisItemCopy))),
        react_1.default.createElement(list_1.List, { "data-cy": "product-feature-bullets-list", items: featureBullets.map((bullet) => (0, view_1.SafeHtmlParse)(bullet)), lineHeight: listLineHeight }))) : null;
};
exports.ProductFeatureBullets = ProductFeatureBullets;
